var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dots"},_vm._l((_vm.maxSlidesNumber+1),function(dot,index){return _c('span',{class:{ active: index === _vm.activeSlide },on:{"click":function($event){return _vm.jump(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }